import { Helmet } from 'react-helmet-async';
import FunnelView from 'src/sections/overview/dashboards/views/funnel';

export default function SearchPerformanceFunnel() {
  return (
    <>
      <Helmet>
        <title>Traffic</title>
      </Helmet>

      <FunnelView />
    </>
  );
}
